import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FeesScreens, getFeeFormOptionsForPayment } from '../fees-details.modal.component';
import { filesExistAndValid, MessageQueryService } from '@certemy/ui-components';
import { StepService } from 'services/professional/step/step.service';
import { FeesStepInstance } from 'services/professional/step/step.interface';
import _get from 'lodash-es/get';
import { UploadConfirmInfo } from 'components/upload-confirm/confirm-info.interface';

@Component({
  selector: 'cm-fees-file-upload-screen',
  templateUrl: './fees-file-upload-screen.component.html',
  styleUrls: ['./fees-file-upload-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeesFileUploadScreenComponent {
  @Input() step: FeesStepInstance;
  @Output() switchScreen = new EventEmitter();
  @Output() closeModal = new EventEmitter();
  @Output() toggleMode = new EventEmitter();
  @Output() dismissModal = new EventEmitter();

  files: File[] = [];
  errorMessages = [];
  showConfirmation = false;
  readonly NO_FILES_ERROR = 'Please add file(s) with appropriate file size';
  readonly FeesScreens = FeesScreens;
  uploadInfo: UploadConfirmInfo;

  constructor(private stepService: StepService, private messageQueryService: MessageQueryService) {}

  onFilesChange(event) {
    this.files = event;
  }

  confirmUpload() {
    if (!filesExistAndValid(this.files)) {
      if (!this.errorMessages.includes(this.NO_FILES_ERROR)) {
        this.errorMessages.push(this.NO_FILES_ERROR);
      }

      return;
    }

    this.errorMessages = [];
    this.uploadInfo = {
      textFields: [
        {
          label: 'Step name:',
          text: this.step.name,
        },
        {
          label: 'Step type:',
          text: this.step.step_type_name,
        },
      ],
      files: this.files,
    };
    this.showConfirmation = true;
    this.toggleMode.emit();
  }

  uploadFiles() {
    this.errorMessages = [];
    const formData: FormData = new FormData();
    formData.append('id', this.step.step_instance_id.toString());

    for (const file of this.files) {
      formData.append('file[]', file, file.name);
    }

    if (_get(this.step.content, 'feesFormFields.length')) {
      formData.append('optionInstances', JSON.stringify(getFeeFormOptionsForPayment(this.step.content.feesFormFields)));
    }

    this.stepService.uploadFeesStepEvidenceDocuments(this.step.step_instance_id, formData).subscribe(() => {
      this.messageQueryService.addMessage('Your document has been submitted for review');
      this.closeModal.emit();
    });
  }

  declineConfirmation() {
    this.toggleMode.emit();
    this.showConfirmation = false;
  }
}
